import { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import illustrationSrc from './assets/thanks-illustration.png';
import {
    Actions,
    CtaButton,
    Footnote,
    IllustrationImg,
    IllustrationWrap,
    Inner,
    Root,
    Text,
    TextBlock,
    Title,
} from './styles';

interface TeachingEvaluationCompleteModalProps {
    teamId?: string;
    courseUrl?: string;
    campaignId?: string;
}

const AUTO_RETURN_SEC = 5;

export const TeachingEvaluationCompleteModal: FC<TeachingEvaluationCompleteModalProps> = () => {
    const { t } = useTranslation();
    const modal = useModal();
    const te = 'teams.adminPage.courseEditPage.teachingEvaluation';
    const [seconds, setSeconds] = useState(AUTO_RETURN_SEC);

    const close = useCallback(() => {
        modal.hide();
    }, [modal]);

    useEffect(() => {
        const timer = window.setInterval(() => {
            setSeconds((prev) => {
                if (prev <= 1) {
                    window.clearInterval(timer);
                    close();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => window.clearInterval(timer);
    }, [close]);

    return (
        <Root>
            <IllustrationWrap>
                <IllustrationImg src={illustrationSrc} alt="" />
            </IllustrationWrap>
            <Inner>
                <TextBlock>
                    <Title>{t(`${te}.thanks.title`)}</Title>
                    <Text>{t(`${te}.thanks.text`)}</Text>
                </TextBlock>
                <Actions>
                    <CtaButton type="button" onClick={close}>
                        {t(`${te}.thanks.cta`)}
                    </CtaButton>
                    <Footnote>{t(`${te}.thanks.autoReturn`, { seconds })}</Footnote>
                </Actions>
            </Inner>
        </Root>
    );
};

export default TeachingEvaluationCompleteModal;
import { FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'core';
import illustrationSrc from './assets/thanks-illustration.png';
import {
    Actions,
    CtaButton,
    Footnote,
    IllustrationImg,
    IllustrationWrap,
    Inner,
    Root,
    Text,
    TextBlock,
    Title,
} from './styles';

interface TeachingEvaluationCompleteModalProps {
    teamId?: string;
    courseUrl?: string;
    campaignId?: string;
}

const AUTO_RETURN_SEC = 5;

export const TeachingEvaluationCompleteModal: FC<TeachingEvaluationCompleteModalProps> = () => {
    const { t } = useTranslation();
    const modal = useModal();
    const te = 'teams.adminPage.courseEditPage.teachingEvaluation';
    const [seconds, setSeconds] = useState(AUTO_RETURN_SEC);

    const close = useCallback(() => {
        modal.hide();
    }, [modal]);

    useEffect(() => {
        const timer = window.setInterval(() => {
            setSeconds((prev) => {
                if (prev <= 1) {
                    window.clearInterval(timer);
                    close();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => window.clearInterval(timer);
    }, [close]);

    return (
        <Root>
            <IllustrationWrap>
                <IllustrationImg src={illustrationSrc} alt="" />
            </IllustrationWrap>
            <Inner>
                <TextBlock>
                    <Title>{t(`${te}.thanks.title`)}</Title>
                    <Text>{t(`${te}.thanks.text`)}</Text>
                </TextBlock>
                <Actions>
                    <CtaButton type="button" onClick={close}>
                        {t(`${te}.thanks.cta`)}
                    </CtaButton>
                    <Footnote>{t(`${te}.thanks.autoReturn`, { seconds })}</Footnote>
                </Actions>
            </Inner>
        </Root>
    );
};

export default TeachingEvaluationCompleteModal;
